// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2Ony0","boxTitle":"Qualiphy_boxTitle__3aiRi","box":"Qualiphy_box__1yFH1","toggleWrap":"Qualiphy_toggleWrap__23yPJ"};